<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <!-- <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Map</div>
            </div>
          </q-card-section> -->

          <q-separator />
          <q-card-section class="q-pa-none">
            <div>
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col mt-0 pt-0"
                  style="height: calc(100vh - 83px) !important"
                >
                  <googleMaps
                    ref="gmap"
                    :center="mapCenter"
                    :zoom="mapZoom"
                    :clustorMarkers="markers"
                    mapType="terrain"
                    :options="{
                      zoomControl: false,
                      fullscreenControl: false,
                      streetViewControl: false,
                      mapTypeControl: true,
                      styles: [
                        {
                          elementType: 'geometry',
                          stylers: [{ color: '#242f3e' }],
                        },
                        {
                          elementType: 'labels.text.stroke',
                          stylers: [{ color: '#242f3e' }],
                        },
                        {
                          elementType: 'labels.text.fill',
                          stylers: [{ color: '#746855' }],
                        },
                        {
                          featureType: 'administrative.locality',
                          elementType: 'labels.text.fill',
                          stylers: [{ color: '#d59563' }],
                        },
                        {
                          featureType: 'poi',
                          elementType: 'labels',
                          stylers: [{ visibility: 'off' }],
                        },
                        {
                          featureType: 'poi.park',
                          elementType: 'geometry',
                          stylers: [{ color: '#263c3f' }],
                        },
                        {
                          featureType: 'poi.park',
                          elementType: 'labels.text.fill',
                          stylers: [{ color: '#6b9a76' }],
                        },
                        {
                          featureType: 'road',
                          elementType: 'geometry',
                          stylers: [{ color: '#38414e' }],
                        },
                        {
                          featureType: 'road',
                          elementType: 'geometry.stroke',
                          stylers: [{ color: '#212a37' }],
                        },
                        {
                          featureType: 'road',
                          elementType: 'labels.text.fill',
                          stylers: [{ color: '#9ca5b3' }],
                        },
                        {
                          featureType: 'road.highway',
                          elementType: 'geometry',
                          stylers: [{ color: '#746855' }],
                        },
                        {
                          featureType: 'road.highway',
                          elementType: 'geometry.stroke',
                          stylers: [{ color: '#1f2835' }],
                        },
                        {
                          featureType: 'road.highway',
                          elementType: 'labels.text.fill',
                          stylers: [{ color: '#f3d19c' }],
                        },
                        {
                          featureType: 'transit',
                          elementType: 'geometry',
                          stylers: [{ color: '#2f3948' }],
                        },
                        {
                          featureType: 'transit.station',
                          elementType: 'labels.text.fill',
                          stylers: [{ color: '#d59563' }],
                        },
                        {
                          featureType: 'water',
                          elementType: 'geometry',
                          stylers: [{ color: '#17263c' }],
                        },
                        {
                          featureType: 'water',
                          elementType: 'labels.text.fill',
                          stylers: [{ color: '#515c6d' }],
                        },
                        {
                          featureType: 'water',
                          elementType: 'labels.text.stroke',
                          stylers: [{ color: '#17263c' }],
                        },
                      ],
                    }"
                    style="
                      height: 100%;
                      width: 100%;
                      position: relative;
                      z-index: 1;
                    "
                    @updatePos="updateCenterPOS"
                    @clustorMapMarkerClicked="
                      (val) =>
                        $router.push(`/mobile-view/survey-mp-report/${val.id}`)
                    "
                    @showMarkers="showDevices"
                  >
                  </googleMaps>
                </div>

                <div class="saveViewBtn">
                  <q-btn
                    color="white"
                    text-color="black"
                    label="Save View"
                    @click="saveView"
                  />
                </div>

                <q-card
                  v-if="showDeviceDetails"
                  class="deviceInfoOverlayCard"
                  tile
                >
                  <q-card-section class="q-pa-sm q-pl-md">
                    <div class="row items-center">
                      <div style="display: inline-block" class="text-h6">
                        Selected Devices
                      </div>
                      <q-space />
                      <q-btn
                        color="accent2"
                        round
                        flat
                        icon="mdi-close"
                        @click="showDeviceDetails = false"
                      >
                      </q-btn>
                    </div>
                  </q-card-section>
                  <q-separator />
                  <q-scroll-area style="height: calc(100% - 60px)">
                    <div
                      class="q-pa-sm q-mb-md"
                      v-for="(device, index) in selectedDevices"
                      :key="`deviceList_${index}`"
                    >
                      <b>Device # </b>{{ device.id }} <br />
                      <hr class="gmapInfoWindowHR" />
                      <table>
                        <tr>
                          <td><b>Battery:</b></td>
                          <td>{{ device.battery }}</td>
                        </tr>
                        <tr>
                          <td><b>Temp:</b></td>
                          <td>{{ device.temp }}</td>
                        </tr>
                        <tr>
                          <td><b>Lat:</b></td>
                          <td>{{ device.lat }}</td>
                        </tr>
                        <tr>
                          <td><b>Long:</b></td>
                          <td>{{ device.long }}</td>
                        </tr>
                        <tr>
                          <td><b>Comment:</b></td>
                          <td>{{ device.comment }}</td>
                        </tr>
                        <tr>
                          <td><b>Is a Hub:</b></td>
                          <td>{{ device.isHub }}</td>
                        </tr>
                        <tr>
                          <td><b>Is Mirroring:</b></td>
                          <td>{{ device.mirror }}</td>
                        </tr>
                        <tr>
                          <td><b>Parent Key:</b></td>
                          <td>{{ device.parentKey }}</td>
                        </tr>
                        <tr>
                          <td><b>Organization:</b></td>
                          <td>{{ device.organizations_name }}</td>
                        </tr>
                        <tr>
                          <td><b>Flagged:</b></td>
                          <td>{{ device.flagged }}</td>
                        </tr>
                        <tr>
                          <td><b>PCB ID:</b></td>
                          <td>{{ device.pcb_id }}</td>
                        </tr>
                        <tr>
                          <td><b>Version:</b></td>
                          <td>{{ device.version }}</td>
                        </tr>
                        <tr>
                          <td><b>Sim:</b></td>
                          <td>{{ device.sim }}</td>
                        </tr>
                        <tr>
                          <td><b>Last message received:</b></td>
                          <td v-if="device.lastMessageReceived">
                            {{ device.lastMessageReceived | momentFromNow }}

                            <q-tooltip>
                              {{ device.lastMessageReceived | momentFormat }}
                            </q-tooltip>
                          </td>
                          <td v-else>No Event Received</td>
                        </tr>
                      </table>
                    </div>
                  </q-scroll-area>
                </q-card>
                <q-card
                  v-if="showDeviceDetails"
                  class="deviceEventsOverlayCard"
                  tile
                >
                  <q-card-section class="q-pa-sm q-pl-md">
                    <div class="row items-center">
                      <div style="display: inline-block" class="text-h6">
                        Device Events
                      </div>
                    </div>
                  </q-card-section>
                  <q-separator />
                  <q-scroll-area style="height: calc(100% - 60px)">
                    <div
                      class="q-pa-sm q-mb-md"
                      v-for="(device, index) in selectedDevices"
                      :key="`deviceList_${index}`"
                    >
                      <b>Device # </b>{{ device.id }} <br />
                      <hr class="gmapInfoWindowHR" />
                      <q-skeleton
                        v-if="deviceEventsLoading"
                        animation="pulse"
                      />
                      <div
                        class="row"
                        v-if="deviceEvents[device.id] && !deviceEventsLoading"
                      >
                        <div
                          class="col-12 cursor-pointer"
                          v-for="(event, eventIndex) in deviceEvents[device.id]"
                          :key="`event_${eventIndex}`"
                        >
                          <div class="row">
                            <div class="col text-capitalize">
                              <b>Type:</b> {{ event.type }}
                            </div>
                            <div class="col">
                              {{ event.created_at | momentFromNow }}
                              <q-tooltip>
                                Server Upload Time <br />
                                {{ device.created_at | momentFormat }}
                              </q-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </q-scroll-area>
                </q-card>

                <q-card class="filtersOverlay shadow-0" tile>
                  <q-card-section class="q-pa-sm q-pl-md">
                    <div class="row items-center">
                      <q-btn
                        flat
                        class="bg-white"
                        color="black"
                        icon="mdi-filter"
                        @click="filterDialog = true"
                      >
                        <q-tooltip>Filters</q-tooltip>
                      </q-btn>
                    </div>
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
      <q-dialog v-model="filterDialog" max-width="600px">
        <q-card
          class="dateRangeDialog"
          v-if="filterDialog"
          tile
          style="width: 90vw; max-width: 600px"
        >
          <q-card-section class="q-pa-sm q-pl-md">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Filters</div>
              <q-space />
              <q-btn
                color="accent2"
                round
                flat
                icon="mdi-close"
                @click="filterDialog = false"
              >
              </q-btn>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <div class="row">
              <div class="col-12">
                <q-radio v-model="deviceFilter" val="all" label="Show All" />
                <q-radio
                  v-model="deviceFilter"
                  val="recentEvents"
                  label="Recent Events"
                />
                <q-radio
                  v-model="deviceFilter"
                  val="failedHeartBeat"
                  label="Failed Heart Beat"
                />
              </div>
            </div>
          </q-card-section>
        </q-card>
      </q-dialog>
    </div>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import googleMaps from "@/components/googleMaps/googleMaps.vue";
  import { colors } from "quasar";

  // import { Notify } from "quasar";

  export default {
    components: { googleMaps },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        devices: "devices/list",
        devicesLoading: "devices/listLoading",
        deviceEvents: "devices/events/list",
        deviceEventsLoading: "devices/events/listLoading",
      }),
    },
    watch: {
      devices: function () {
        this.init();
      },
      deviceFilter: function () {
        this.init();
      },
    },
    data: () => ({
      // data-table
      markers: [],

      showDeviceDetails: false,
      selectedDevices: [],

      search: "",

      filterDialog: false,
      deviceFilter: "all",
      mapCenter: { lng: 172.64715, lat: -43.5781 },
      mapZoom: 7,
    }),
    beforeCreate() {
      this.$store.dispatch("devices/loadAll");
    },
    mounted() {
      this.loadView();
      this.init();
    },
    methods: {
      init() {
        this.markers = [];
        this.devices.forEach((device) => {
          if (this.checkDeviceFilter(device)) {
            if (device.lat && device.long && parseFloat(device.lat) != 0) {
              this.markers.push({
                lat: parseFloat(device.lat),
                lng: parseFloat(device.long),
                data: device,
                icon: `https://simple-software-tools.s3.ap-southeast-2.amazonaws.com/map-icons/mapicon-${this.markerColor(
                  device.lastMessageReceived
                )}-resized.png`,
              });
            } else if (
              device.deploymentLat &&
              device.deploymentLng &&
              parseFloat(device.deploymentLat) != 0
            ) {
              this.markers.push({
                lat: parseFloat(device.deploymentLat),
                lng: parseFloat(device.deploymentLng),
                data: device,
                icon: `https://simple-software-tools.s3.ap-southeast-2.amazonaws.com/map-icons/mapicon-${this.markerColor(
                  device.lastMessageReceived
                )}-resized.png`,
              });
            }
          }
        });
      },
      checkDeviceFilter(device) {
        if (this.deviceFilter == "all") return true;
        if (
          this.deviceFilter == "recentEvents" &&
          moment(device.lastMessageReceived).isAfter(
            moment().subtract(24, "hours")
          )
        )
          return true;
        if (this.deviceFilter == "failedHeartBeat" && device.heartbeatFlag)
          return true;
        return false;
      },
      markerColor(lastMessageReceived) {
        if (moment(lastMessageReceived).isAfter(moment().subtract(2, "hours")))
          return "red";
        if (moment(lastMessageReceived).isAfter(moment().subtract(12, "hours")))
          return "orange";
        if (moment(lastMessageReceived).isAfter(moment().subtract(24, "hours")))
          return "green";
        return "blue-gray";
      },
      updateCenterPOS(position) {
        // console.log(position);
        this.$refs.gmap.panToLocation(position);
      },
      showDevices(idList) {
        this.selectedDevices = [];

        this.devices.forEach((device) => {
          if (idList.includes(device.id)) {
            this.selectedDevices.push(device);
          }
        });
        this.showDeviceDetails = true;

        // Loading events for selected devices
        this.$store.dispatch("devices/events/loadAll", {
          limit: 5,
          ids: idList,
        });
      },

      saveView() {
        console.log("Save View");
        this.$refs.gmap.$refs.googleMaps.$mapPromise.then((map) => {
          const center = map.getCenter();
          const zoom = map.getZoom();
          const viewSettings = {
            lat: center.lat(),
            lng: center.lng(),
            zoom: zoom,
          };
          console.log(JSON.stringify(viewSettings));
          localStorage.setItem("map_view_settings", JSON.stringify(viewSettings));
          this.$q.notify({
            type: "positive",
            message: "Map view saved successfully.",
            position: "top",
          });
        });
      },
      loadView() {
        const savedView = localStorage.getItem("map_view_settings");
        if (savedView) {
          try {
            const parsedView = JSON.parse(savedView);
            if (parsedView.lat && parsedView.lng && parsedView.zoom) {
              this.mapCenter = { lat: parsedView.lat, lng: parsedView.lng };
              this.mapZoom = parsedView.zoom;
            }
          } catch (e) {
            console.error("Failed to load map view settings", e);
          }
        }
      },
    },
  };
</script>

<style scoped>
  #depthCard:hover {
    background: #5cb3ff;
    color: white;
  }

  .deviceInfoOverlayCard {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
    background: rgba(255, 255, 255, 0.6);
    height: 50%;
    width: 280px;
  }
  .deviceEventsOverlayCard {
    position: absolute;
    bottom: 20px;
    right: 10px;
    z-index: 1;
    background: rgba(255, 255, 255, 0.6);
    height: 40%;
    width: 280px;
  }

  .filtersOverlay {
    position: absolute;
    top: 100px;
    left: 0px;
    z-index: 1;
    background: rgba(255, 255, 255, 0);
    height: 40%;
    width: 280px;
  }

  .saveViewBtn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
  }
</style>
